namespace $ {
	export let $mol_array_lottery_sync = $mol_wire_sync( $mol_array_lottery ) as typeof $mol_array_lottery
}
